import '../pipeline/landing/landing.sass';

require.context('../pipeline/landing/images', true);
